import CustomChip from '../../../components/CustomChip';
import { useLanguage } from '../../../contexts/language';
import { InvoiceStatus } from '../../../types/invoices';
import { BADGE_CLASSNAMES } from '../../../utils/styles';

interface StatusBadgeProps {
  status: InvoiceStatus;
  small?: boolean;
}

const getChipClasses = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.Approved:
      return BADGE_CLASSNAMES.GREEN;
    case InvoiceStatus.Rejected:
      return BADGE_CLASSNAMES.RED;
    case InvoiceStatus.PendingApproval:
      return BADGE_CLASSNAMES.YELLOW;
    default:
      return '';
  }
};

const StatusBadge = ({ status, small }: StatusBadgeProps) => {
  const chipClass = getChipClasses(status);
  const { t } = useLanguage();

  return (
    <CustomChip
      label={t(`invoice-status.${status}`)}
      className={chipClass}
      small={small}
    />
  );
};

export default StatusBadge;
